import React, { useState, useEffect } from 'react';
import { FaHourglassHalf, FaTimes } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import axios from 'axios';

const RaiseUnderReviewVoice = () => {
  const [advertisements, setAdvertisements] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);
  // Add new state for preview modal
  const [previewMedia, setPreviewMedia] = useState(null);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // Function to handle media click
  const handleMediaClick = (media, type) => {
    setPreviewMedia({
      url: media.startsWith('http')
        ? media
        : `${process.env.REACT_APP_API_BASE_URL}/${media.replace(/\\/g, '/')}`,
      type: type
    });
  };

  // Function to close the preview modal
  const closePreview = () => {
    setPreviewMedia(null);
  };

  useEffect(() => {
    const fetchAds = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/get/pending/ryv/post`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        console.log("this is underReview", response);

        const data = response.data.data || response.data;
        // If the API returns { data: [...] }, use that array
        const underReviewVoices = Array.isArray(data) ? data : data.data;
        setAdvertisements(underReviewVoices);
        setPendingCount(underReviewVoices.length);
      } catch (error) {
        toast.error('Failed to load under review advertisements');
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, []);

  // Sort advertisements by createdAt descending (newest first)
  const sortedAdvertisements = [...advertisements].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  // Pagination calculations
  const totalPages = Math.ceil(sortedAdvertisements.length / rowsPerPage);
  const paginatedAdvertisements = sortedAdvertisements.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="p-6">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Media Preview Modal */}
      {previewMedia && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" onClick={closePreview}>
          <div className="relative max-w-4xl max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()}>
            <button
              className="absolute top-4 right-4 bg-red-500 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:bg-red-700"
              onClick={closePreview}
            >
              <FaTimes />
            </button>
            {previewMedia.type === 'image' ? (
              <img
                src={previewMedia.url}
                alt="Preview"
                className="max-w-full max-h-[85vh] object-contain"
              />
            ) : (
              <video
                src={previewMedia.url}
                controls
                autoPlay
                className="max-w-full max-h-[85vh]"
              />
            )}
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800">UnderReview Raise Voices</h1>
        <div className="flex flex-wrap gap-2">
          <Link to="/raise/approvedvoice" className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600">Approved Voices</Link>
          <Link to="/raise/runningvoice" className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">Running Voices</Link>
          <Link to="/raise/rejectedvoice" className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600">Rejected Voices</Link>
        </div>
      </div>

      <div className="mb-8">
        <div className="bg-yellow-500 p-6 rounded-xl shadow-lg text-white">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium opacity-80">Under Review Advertisements</p>
              <p className="text-2xl font-bold mt-1">{pendingCount}</p>
            </div>
            <FaHourglassHalf className="w-10 h-10 opacity-80" />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
        </div>
      ) : advertisements.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <FaHourglassHalf className="w-16 h-16 mx-auto text-gray-300 mb-4" />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">No Under Review Advertisements</h3>
          <p className="text-gray-500">You don't have any under review advertisements at the moment.</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-xl shadow-sm border border-gray-100">
            <thead>
              <tr className="bg-yellow-100 text-yellow-800">
                <th className="px-4 py-2 text-left">Media</th>
                <th className="px-4 py-2 text-left">RYV ID</th>
                <th className="px-4 py-2 text-left">User ID</th>
                <th className="px-4 py-2 text-left">Location (State/City)</th>
                <th className="px-4 py-2 text-left">Residence Address</th>
                <th className="px-4 py-2 text-left">Description</th>
                <th className="px-4 py-2 text-left">Created At</th>
                <th className="px-4 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {paginatedAdvertisements.map((voice) => (
                <tr key={voice._id} className="border-b">
                  <td className="px-4 py-3 border-b border-gray-100">
                    {voice.image && (
                      <img
                        src={voice.image.startsWith('http') ? voice.image : `${process.env.REACT_APP_API_BASE_URL}/${voice.image.replace(/\\/g, '/')}`}
                        alt="media"
                        className="w-12 h-12 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={() => handleMediaClick(voice.image, 'image')}
                      />
                    )}
                    {voice.video && (
                      <video
                        src={voice.video.startsWith('http') ? voice.video : `${process.env.REACT_APP_API_BASE_URL}/${voice.video.replace(/\\/g, '/')}`}
                        className="w-12 h-12 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={() => handleMediaClick(voice.video, 'video')}
                      />
                    )}
                  </td>
                  <td className="px-4 py-2 font-semibold">{voice._id}</td>
                  <td className="px-4 py-2">{voice.userId}</td>
                  <td className="px-4 py-2">{voice.state}, {voice.city}</td>
                  <td className="px-4 py-2">{voice.residenceAddress}</td>
                  <td className="px-4 py-2 text-sm">{voice.description}</td>
                  <td className="px-4 py-2 text-xs">
                    {voice.createdAt ? (
                      <>
                        {new Date(voice.createdAt).toLocaleDateString('en-IN', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })}
                        <br />
                        {new Date(voice.createdAt).toLocaleTimeString('en-IN', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })}
                      </>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    <span className="px-2 py-1 bg-yellow-100 text-yellow-800  text-xs font-medium flex items-center w-max">
                      {voice.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <nav className="inline-flex flex-wrap items-center space-x-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-4 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              Previous
            </button>
            {/* Page number buttons */}
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`px-3 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors font-semibold ${currentPage === page ? 'bg-yellow-300 text-yellow-900' : ''}`}
                aria-current={currentPage === page ? 'page' : undefined}
              >
                {page}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-4 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              Next
            </button>
          </nav>
        </div>
      )}
    </div>
  );
};

export default RaiseUnderReviewVoice;
